import { getAuthentication } from './auth';

// Declarations
type TMethods = 'GET' | 'POST' | 'PUT' | 'DETETE';

export interface IRequestOptions {
    method: TMethods;
    body?: string;
    query?: object;
}
export async function request(url: string, { query, ...options }: IRequestOptions) {

    // Headers
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const auth = getAuthentication();
    if (auth) {
        headers.append('Authorization', auth);
    }

    // Request
    const queryString = typeof query === 'object' ? `?${objectToQuery(query)}` : '';
    const response = await fetch(url + queryString, { ...options, headers });

    if (response.ok) {
        return response.json();
    }

    return Promise.reject({
        status: response.status,
        statusText: response.statusText
    });
}

// Helpers
export function objectToQuery(obj: object) {
    return Object.keys(obj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`).join('&');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utilities/http.ts